import { z } from "zod/v4";
import { THRESHOLDS, type Threshold } from "./v2/probabilistic/thresholds";

/** Simple create-wizard probabilistic config (Threshold presets only). */
export type IdrSimpleProbabilisticConfig = {
  enabled: boolean;
  thresholds?: Array<{ threshold: Threshold }>;
};

/** Runtime validator for {@link IdrSimpleProbabilisticConfig}. Rejects advanced JSON. */
export const IdrSimpleProbabilisticConfigSchema = z
  .object({
    enabled: z.boolean(),
    thresholds: z
      .array(
        z.object({
          threshold: z.enum(THRESHOLDS),
        }),
      )
      .optional(),
  })
  .strict();

export function parseIdrSimpleProbabilisticConfig(
  config: unknown,
): IdrSimpleProbabilisticConfig {
  return IdrSimpleProbabilisticConfigSchema.parse(config);
}
